import { render, staticRenderFns } from "./MultipleOptionsSettings.vue?vue&type=template&id=de2cd4ee&scoped=true&"
import script from "./MultipleOptionsSettings.vue?vue&type=script&lang=js&"
export * from "./MultipleOptionsSettings.vue?vue&type=script&lang=js&"
import style0 from "./MultipleOptionsSettings.vue?vue&type=style&index=0&id=de2cd4ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2cd4ee",
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect});
